var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"risk-imgs"},_vm._l((_vm.imgList),function(img,i){return _c('img',{key:i,attrs:{"src":img,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }